module.exports = __webpack_public_path__ + "files/e629452688076c6c665d3defa4bb8939.svg";